import React from 'react';
import { Box } from '@mui/material';

import { FormInput } from '@occc-app/Offer/components/FormInput';

import { ProductGroupSelectEnhancedContainer as ProductGroupSelect } from './ProductGroupSelectEnhanced/ProductGroupSelectEnhancedContainer';

import {
  greaterThanZeroValidation,
  numberValidation,
  requiredValidation,
  withFormEventValidation,
} from '../../validatableComponent';
import { State } from '../redux';

const AccumulationThresholdFormInput = withFormEventValidation(
  FormInput,
  requiredValidation,
  numberValidation,
  greaterThanZeroValidation,
);

type ComponentState = State['emConfiguration']['totalSpendOverTime'];
type Fields = keyof ComponentState;
export type Props = ComponentState & {
  editMode: boolean;
  fieldDisabled: (field: Fields) => boolean;
};

const TotalSpendOverTimeConfiguration: React.FC<Props> = (props) => {
  const { accumulationThreshold, editMode, ineligibleProductGroups, fieldDisabled } = props;

  return (
    <Box>
      <Box mb={4}>
        <AccumulationThresholdFormInput
          id='accumulationThreshold'
          label='Accumulation Threshold'
          readonly={fieldDisabled('accumulationThreshold')}
          type='text'
          value={accumulationThreshold}
          required={true}
        />
      </Box>

      <Box mb={4}>
        <ProductGroupSelect
          editMode={editMode}
          label='Excluded Product Groups'
          onChange={() => {}}
          readonly={fieldDisabled('ineligibleProductGroups')}
          selectedProductGroups={ineligibleProductGroups}
          ineligibleType={true}
        />
      </Box>
    </Box>
  );
};

export { TotalSpendOverTimeConfiguration };
